import React, { useEffect, useState } from 'react'
import "./reviews.scss"
import { FaQuestionCircle } from 'react-icons/fa'
import { MdKeyboardArrowLeft, MdKeyboardArrowRight, MdStar, MdStarOutline } from 'react-icons/md'
import axios from 'axios';
import moment from 'moment';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';

function Reviews() {
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState(null);
    const [showGoogleButton, setShowGoogleButton] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [reviewId, setReviewId] = useState('');
    const [comment, setComment] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const [totalPages, setTotalPages] = useState(null);
    const [content, setContent] = React.useState([]);
    const [locations, setLocations] = React.useState([]);
    const [location, setLocation] = React.useState('');

    const filteredData = content.length > 0 ? [...content].filter(row =>
        Object.values(row).some(value =>
            value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
    ) : [];

    // const handleSearchChange = event => {
    //     setSearchQuery(event.target.value);
    //     setCurrentPage(1); // Reset current page when the search query changes
    // };

    const paginatedData = filteredData.length > 0 ? [...filteredData].slice((currentPage - 1) * pageSize, currentPage * pageSize) : [];

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const previousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('idToken');
        localStorage.removeItem('user');
    };

    const refreshAccessToken = async () => {
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
            try {
                const res = await axios.post('https://goodreviews.co/api/refresh-token', { refreshToken });
                const { accessToken, idToken } = res.data;
                // console.log(res.data, 'refreshData')
                localStorage.setItem('accessToken', accessToken);
                localStorage.setItem('idToken', idToken);
                return { accessToken, idToken };
            } catch (error) {
                console.error('Failed to refresh access token', error);
                handleLogout();
            }
        } else {
            handleLogout();
        }
    };

    const getReviewsByLocation = async (locationId) => {
        Swal.fire({
            html: `<img src='/circle-1700_256.gif' style="height: 60px" alt="" />`,
            customClass: { popup: 'loader' },
            showConfirmButton: false,
            heightAuto: false
        })
        let { accessToken, idToken } = await refreshAccessToken();
        let userId = JSON.parse(localStorage.getItem('user') || '{}').sub;
        try {
            const res = await axios.get('https://goodreviews.co/api/getReviewsByLocation/' + userId + '/' + locationId, {
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    Accesstoken: accessToken
                },
            });
            //   return res.data;
            let totalReviews = res.data.reviews ? res.data.reviews : [];
            setContent(totalReviews);
            setTotalPages(Math.ceil(totalReviews.length / 10));
        } catch (error) {
            console.error('Failed to make authenticated API call', error);
        } finally {
            Swal.close()
        }
    };

    const getReviews = async () => {
        Swal.fire({
            html: `<img src='/circle-1700_256.gif' style="height: 60px" alt="" />`,
            customClass: { popup: 'loader' },
            showConfirmButton: false,
            heightAuto: false
        })
        let { accessToken, idToken } = await refreshAccessToken();
        let userId = JSON.parse(localStorage.getItem('user') || '{}').sub;
        try {
            const res = await axios.get('https://goodreviews.co/api/getReviews/' + userId, {
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    Accesstoken: accessToken
                },
            });
            //   return res.data;
            let totalLocations = res.data.locations ? res.data.locations : [];
            let totalReviews = res.data.reviews ? res.data.reviews : [];
            setLocations(totalLocations);
            setContent(totalReviews);
            setTotalPages(Math.ceil(totalReviews.length / 10));
        } catch (error) {
            console.error('Failed to make authenticated API call', error);
        } finally {
            Swal.close()
        }
    };

    const updateReply = async () => {
        Swal.fire({
            html: `<img src='/circle-1700_256.gif' style="height: 60px" alt="" />`,
            customClass: { popup: 'loader' },
            showConfirmButton: false,
            heightAuto: false
        })
        let { accessToken, idToken } = await refreshAccessToken();
        let userId = JSON.parse(localStorage.getItem('user') || '{}').sub;
        let locationId = location.replace("locations/", "");
        
        const res = await axios.post('https://goodreviews.co/api/updateReview',
            { userId, locationId, reviewId, comment },
            {
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    Accesstoken: accessToken
                }
            }
        );
        // console.log(res);
        if (res.data.comment) {
            Swal.fire({
                text: 'Success',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000,
                heightAuto: false
            }).then(() => {
                setShowUpdateModal(false);
                setComment('');
                setReviewId('');
                 if(location){
                     let locId = location.replace('locations/', '')
                     getReviewsByLocation(locId);
                 }else{
                     getReviews();
                 }
            })
        } else {
            Swal.close()
        }
    }

    useEffect(() => {
        if (locations.length > 0) {
          setLocation(locations[0].name);
        }
    }, [locations])

    useEffect(() => {
        (async () => {
            setSearchQuery('');
            if (localStorage.getItem('refreshToken') || localStorage.getItem('idToken')) {
                if(location){
                    let locationId = location.replace('locations/', '')
                    getReviewsByLocation(locationId)
                }else{
                    getReviews();
                }
                setShowGoogleButton(false);
            }else{
              setShowGoogleButton(true);
            }
        })()
    }, [location])

    const handleLoginSuccess = async (tokenResponse) => {
      const { code } = tokenResponse;

      // Exchange the code for tokens at the backend
      try {
        const res = await axios.post(
          "https://goodreviews.co/api/google-login",
          { code, correl_id: userInfo.correl_id }
        );
        console.log(res, "loginData");
        const { idToken, accessToken, refreshToken, user } = res.data;

        // Store tokens and user information in local storage
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem("idToken", idToken);
        localStorage.setItem("user", JSON.stringify(user));
        navigate("/dashboard");
      } catch (error) {
        console.error("Failed to login with Google", error);
      }
    };

    const login = useGoogleLogin({
      onSuccess: handleLoginSuccess,
      onError: () => console.log("Login Failed"),
      scope: "https://www.googleapis.com/auth/business.manage",
      flow: "auth-code",
    });

    useEffect(() => {
      let userData = JSON.parse(localStorage.getItem("userData") || "{}");
      setUserInfo(userData);
    }, []);

    return (
      <div className="reviews-page">
        {showUpdateModal && (
          <div
            className="overlay-review"
            onClick={() => {
              setShowUpdateModal(false);
              setComment("");
              setReviewId("");
            }}
          ></div>
        )}
        {showUpdateModal && (
          <div className="updateReviewModal card px-4 py-3">
            <h6 className="mb-3">Reply</h6>
            <textarea
              type="text"
              className="form-control"
              placeholder=""
              value={comment}
              rows="4"
              onChange={(ev) => {
                setComment(ev.target.value);
              }}
            />
            <div className="text-center mt-3">
              <button
                className="btn btn-dark me-3"
                onClick={() => {
                  updateReply();
                }}
              >
                Submit
              </button>
              <button
                className="btn btn-dark"
                onClick={() => {
                  setShowUpdateModal(false);
                  setComment("");
                  setReviewId("");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
        <div className="reviews-container">
          <div className="headingContainer d-flex justify-content-between">
            <h5 className="heading mb-0">Google Reviews</h5>
            {/* <FaQuestionCircle color="#E9C877" className="heading-icon" /> */}
          </div>
          {showGoogleButton === false && (<p className="mb-0 reviews-desc mb-3">List of all your reviews</p>)}
          {showGoogleButton === false && (
            <div className="form-group w-100">
              {locations.length > 1 && (
                <h6 className="mb-0 reviews-desc mb-2">
                  <strong>Select Your Google Business Profile</strong>
                </h6>
              )}
              {locations.length > 1 && (
                <select
                  name="Locations"
                  className="form-select"
                  placeholder="Locations"
                  value={location}
                  onChange={(ev) => {
                    let val = ev.target.value;
                    if (val) {
                      setLocation(val);
                    } else {
                      getReviews();
                    }
                  }}
                >
                  {locations &&
                    locations.length > 0 &&
                    locations.map((loc) => (
                      <option key={loc.name} value={loc.name}>
                        {loc.title}
                      </option>
                    ))}
                </select>
              )}
            </div>
          )}
          {showGoogleButton === false && (
            <div className="reviews-card">
              <div className="table-container">
                <table className="table">
                  <thead className="text-start">
                    <tr>
                      <th scope="col">Source</th>
                      <th scope="col">Date</th>
                      <th scope="col">From</th>
                      <th scope="col">Rating</th>
                      <th scope="col">Comment</th>
                      <th scope="col" className="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="justify-content-center">
                    {paginatedData &&
                      paginatedData.length > 0 &&
                      paginatedData.map((row, index) => (
                        <tr
                          className="text-start align-items-center"
                          key={"review-" + index}
                        >
                          <td style={{ verticalAlign: "middle" }}>
                            <img
                              src={row.reviewer.profilePhotoUrl}
                              alt=""
                              className="profile-image"
                            />
                          </td>
                          <td style={{ textWrap: "nowrap" }}>
                            {moment(row.updateTime).format("DD-MMM-YYYY")}
                          </td>
                          <td>{row.reviewer.displayName}</td>
                          <td style={{ textWrap: "nowrap" }}>
                            {row.starRating === "FIVE" && (
                              <div className="d-flex">
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStar color="#E9C877" fontSize={"20px"} />
                              </div>
                            )}
                            {row.starRating === "FOUR" && (
                              <div className="d-flex">
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStarOutline
                                  color="#E9C877"
                                  fontSize={"20px"}
                                />
                              </div>
                            )}
                            {row.starRating === "THREE" && (
                              <div className="d-flex">
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStarOutline
                                  color="#E9C877"
                                  fontSize={"20px"}
                                />
                                <MdStarOutline
                                  color="#E9C877"
                                  fontSize={"20px"}
                                />
                              </div>
                            )}
                            {row.starRating === "TWO" && (
                              <div className="d-flex">
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStarOutline
                                  color="#E9C877"
                                  fontSize={"20px"}
                                />
                                <MdStarOutline
                                  color="#E9C877"
                                  fontSize={"20px"}
                                />
                                <MdStarOutline
                                  color="#E9C877"
                                  fontSize={"20px"}
                                />
                              </div>
                            )}
                            {row.starRating === "ONE" && (
                              <div className="d-flex">
                                <MdStar color="#E9C877" fontSize={"20px"} />
                                <MdStarOutline
                                  color="#E9C877"
                                  fontSize={"20px"}
                                />
                                <MdStarOutline
                                  color="#E9C877"
                                  fontSize={"20px"}
                                />
                                <MdStarOutline
                                  color="#E9C877"
                                  fontSize={"20px"}
                                />
                                <MdStarOutline
                                  color="#E9C877"
                                  fontSize={"20px"}
                                />
                              </div>
                            )}
                          </td>
                          <td>{row.comment ? row.comment : ""}</td>
                          <td className="text-center">
                            <button
                              className="btn btn-dark py-1 px-3 rounded-pill"
                              style={{ textWrap: "nowrap" }}
                              onClick={() => {
                                setShowUpdateModal(true);
                                setReviewId(row.reviewId);
                                setComment(
                                  row.reviewReply ? row.reviewReply.comment : ""
                                );
                              }}
                            >
                              {row.reviewReply ? "Update Reply" : "Reply"}
                            </button>
                          </td>
                        </tr>
                      ))}
                    {paginatedData && paginatedData.length === 0 && (
                      <tr className="text-start align-items-center">
                        <td style={{ verticalAlign: "middle" }}>
                          No reviews found
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-end align-items-center mt-3">
                <button
                  className="btn btn-light me-2"
                  onClick={previousPage}
                  disabled={currentPage === 1}
                >
                  <MdKeyboardArrowLeft />
                </button>
                <span>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-light ms-2"
                  onClick={nextPage}
                  disabled={currentPage === totalPages}
                >
                  <MdKeyboardArrowRight />
                </button>
              </div>
            </div>
          )}
          {showGoogleButton === true && (
            <div className="reviews-card">
              <h5 className="mb-4">
                Looks like you didn't connect your Google Business Account.
                Please click here
              </h5>
              {showGoogleButton && (
                <div className="text-center">
                  <button
                    className="btn btn-dark"
                    onClick={() => {
                      login();
                    }}
                  >
                    <img
                      src={require("../../assets/google-icon.png")}
                      style={{ height: "25px", marginRight: "10px" }}
                      alt=""
                    />
                    Connect to Google
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
}

export default Reviews
